import { Button, InputField } from '@design-system';
import { getCurrencySymbolByCode } from '@utils/locations';
import { formatPrice } from '@utils/prices';
import { useTranslation } from 'next-i18next';

import { CurrencyCode } from '../../../types/Locations';
import {
  OrderReviewSummary,
  OrderReviewSummaryProps,
} from '../OrderReview/OrderReviewSummary';

export type BidProps = {
  artistName: string;
  currencyCode: CurrencyCode;
  error?: string;
  minimumBid: number;
  onChange: (value: string) => void;
  onSubmit: () => void;
  summaryProps: Omit<OrderReviewSummaryProps, 'showPreview'>;
  value: string;
};

export const Bid = ({
  artistName,
  currencyCode,
  error,
  minimumBid,
  onChange,
  onSubmit,
  summaryProps,
  value,
}: BidProps) => {
  const { t } = useTranslation('checkout');
  const amount = String(formatPrice(minimumBid, currencyCode));

  return (
    <form
      className="flex w-full flex-col gap-9 lg:gap-12"
      noValidate
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      <h2 className="text-center text-md font-bold text-neutral-6 lg:text-lg">
        {t('orderReview.auction.title', { artistName })}
      </h2>

      <div className="flex flex-col gap-3">
        <label htmlFor="checkout-bid">
          <span className="block font-bold">{t('bid.title')}</span>
          <span className="block">{t('bid.minimum', { amount })}</span>
        </label>
        <InputField
          error={error}
          id="checkout-bid"
          inputMode="decimal"
          name="bid"
          note={t('bid.note', { amount })}
          onChange={(event) => {
            onChange(event.currentTarget.value);
          }}
          placeholder={t('bid.placeholder')}
          prefix={getCurrencySymbolByCode(currencyCode)}
          value={value}
        />
      </div>

      <div className="lg:hidden">
        <OrderReviewSummary {...summaryProps} />
      </div>

      <Button
        disabled={value.trim() === ''}
        fullWidth
        label={t('orderReview.continue')}
        type="submit"
        variant="primary"
      />
    </form>
  );
};
